import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_BASE_URL;

export const fetchDistricts = createAsyncThunk(
  "district/gitAllDistrict",
  async (thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/district/gitAllDistrict`;
      const resp = await axios(url, {
        credentials: "include",
      });

      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("404 Not Found");
    }
  }
);

export const fetchMandals = createAsyncThunk(
  "mandals/fetchMandals",
  async () => {
    const API_URL = `${Baseurl}/api/v1/mandals`;
    const response = await axios.get(API_URL);
    return response.data;
  }
);
export const addMandal = createAsyncThunk(
  "mandals/addMandal",
  async (mandalData) => {
    
    const url  = `${Baseurl}/api/v1/mandals`;
    const response = await axios.post(url, mandalData);
    return response.data;
  }
);

export const updateMandal = createAsyncThunk(
  "mandals/updateMandal",
  async ({ id, mandalData }) => {
    const API_URL  = `${Baseurl}/api/v1/mandals`;
    const response = await axios.put(`${API_URL}/${id}`, mandalData);
    return response.data;
  }
);

export const deleteMandal = createAsyncThunk(
  "mandals/deleteMandal",
  async (id) => {
    const API_URL = `${Baseurl}/api/v1/mandals`;
    await axios.delete(`${API_URL}/${id}`);
    return id;
  }
);
const districtSlice = createSlice({
  name: "districts",
  initialState: {
    data: [],
    mandals: JSON.parse(localStorage.getItem("mandals")) || [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistricts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDistricts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchDistricts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMandals.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMandals.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.mandals = action.payload;
        localStorage.setItem("mandals", JSON.stringify(action.payload));
      })
      .addCase(fetchMandals.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
    builder
      .addCase(addMandal.fulfilled, (state, action) => {
        state.mandals.push(action.payload);
        localStorage.setItem("mandals", JSON.stringify(state.mandals));
      })
      .addCase(updateMandal.fulfilled, (state, action) => {
        const index = state.mandals.findIndex(
          (mandal) => mandal._id === action.payload._id
        );
        if (index !== -1) {
          state.mandals[index] = action.payload;
          localStorage.setItem("mandals", JSON.stringify(state.mandals));
        }
      })
      .addCase(deleteMandal.fulfilled, (state, action) => {
        state.mandals = state.mandals.filter(
          (mandal) => mandal._id !== action.payload
        );
        localStorage.setItem("mandals", JSON.stringify(state.mandals));
      });
  },
});

export default districtSlice.reducer;
